// src/pages/autoridades/GranCuadro.jsx
import { useEffect } from 'react';

// Estructura de datos del Gran Cuadro
const granMaestria = [
  { cargo: "Gran Maestro", titulo: "M.·.R.·.H.·.", nombre: "Luis Antonio Tipacti Peña", logia: "" },
  { cargo: "Past Gran Maestro Inmediato", titulo: "M.·.R.·.H.·.", nombre: "Carlos Antonio Tejeda Rojas", logia: "162" },
  { cargo: "Vice Gran Maestro", titulo: "R.·.H.·.", nombre: "Diego Agustín del Rosario del Rosario", logia: "62" },
];

const grandesOficiales = [
  { cargo: "Primer Gran Vigilante", titulo: "R.·.H.·.", nombre: "Carlos Iván Tantalean Rojas", logia: "143" },
  { cargo: "Segundo Gran Vigilante", titulo: "R.·.H.·.", nombre: "Rino Josué Cotera Córdova", logia: "223" },
  { cargo: "Gran Orador", titulo: "R.·.H.·.", nombre: "Jorge Luis Suazo Cavero", logia: "156" },
  { cargo: "Gran Secretario", titulo: "R.·.H.·.", nombre: "Manuel Rodrigo Arce Ramírez", logia: "138" },
  { cargo: "Gran Tesorero", titulo: "R.·.H.·.", nombre: "Jaime Rómulo Chahua Damián", logia: "62" },
  { cargo: "Gran Director de Ceremonias", titulo: "R.·.H.·.", nombre: "Hugo Francisco Díaz Aguinaga", logia: "127" },
  { cargo: "Gran Primer Diácono", titulo: "R.·.H.·.", nombre: "Carlos Arturo Ángeles Cáceres", logia: "69" },
  { cargo: "Gran Segundo Diácono", titulo: "R.·.H.·.", nombre: "Jorge Alberto Abad Navarro", logia: "109" },
  { cargo: "Gran Abanderado", titulo: "R.·.H.·.", nombre: "Víctor Miguel Vílchez Figuerola", logia: "225" },
  { cargo: "Gran Porta Estandarte", titulo: "R.·.H.·.", nombre: "Carlos Augusto Cáceres Luque", logia: "114" },
  { cargo: "Gran Porta Espada", titulo: "R.·.H.·.", nombre: "Antonio Zalatiel Terrones Borrego", logia: "116" },
  { cargo: "Gran Guarda Templo Interior", titulo: "R.·.H.·.", nombre: "Jesús Guillermo Chang Martínez", logia: "192" },
  { cargo: "Gran Guarda Templo Exterior", titulo: "R.·.H.·.", nombre: "Walter Ángeles Rivera", logia: "79" },
  { cargo: "Gran Director de Armonía", titulo: "R.·.H.·.", nombre: "Marcos Eduardo Gonzales Martínez", logia: "132" },
  { cargo: "Gran Director de Protocolo", titulo: "R.·.H.·.", nombre: "Edgardo Enrique Rondón de la Cruz", logia: "76" },
  { cargo: "Gran Canciller", titulo: "R.·.H.·.", nombre: "Roque Alberto Díaz Delgado", logia: "1" },
  { cargo: "Gran Guarda Gran Guarda Sellos", titulo: "R.·.H.·.", nombre: "Ricardo Enrique Ríos Ríos", logia: "230" },
  { cargo: "Gran Hospitalario", titulo: "R.·.H.·.", nombre: "Víctor Félix Cárdenas Suasnabar", logia: "4" },
  { cargo: "Gran Guarda Mayor (Córpac)", subCargo: "G.·.T.·. Julio F. Iriarte", titulo: "R.·.H.·.", nombre: "Guillermo Vásquez Alcázar", logia: "121" },
  { cargo: "Gran Guarda Mayor (Halcones)", subCargo: "G.·.T.·. Logias Fundadoras", titulo: "R.·.H.·.", nombre: "José Alfredo G. Guzmán Estrada", logia: "227" },
  { cargo: "Gran Guarda Mayor (Centro de Lima)", subCargo: "G.·.T.·. Jesús García Maldonado", titulo: "R.·.H.·.", nombre: "Félix Fabián Prieto Zavaleta", logia: "155" },
  { cargo: "Gran Guarda Mayor (Callao)", subCargo: "G.·.T.·. Manuel Cipriano Dulanto V.", titulo: "R.·.H.·.", nombre: "Ricardo Teodoro Lucas Rugel Araujo", logia: "211" },
  { cargo: "Gran Director de Prensa y Difusión", titulo: "R.·.H.·.", nombre: "José Javier Horna Placido", logia: "7" },
  { cargo: "Gran Secretario de Regiones", titulo: "R.·.H.·.", nombre: "Luis Alberto Temoche Valdivia", logia: "18" },
];

const GranCuadro = () => {
  // Efecto para hacer scroll al inicio al cargar la vista
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#050505] text-white selection:bg-[#C5A059] selection:text-[#050505] font-sans pt-24 flex flex-col">
      
      {/* Hero Section */}
      <section className="relative w-full pt-32 pb-16 md:pt-40 md:pb-24 flex flex-col items-center justify-center overflow-hidden border-b border-white/5">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-20"
          style={{ backgroundImage: "url('https://images.unsplash.com/photo-1541888086925-921eb234c900?q=80&w=2000&auto=format&fit=crop')" }} 
        ></div>
        <div className="absolute inset-0 bg-gradient-to-b from-[#050505]/90 via-[#050505]/60 to-[#050505]"></div>

        <div className="relative z-10 text-center px-4 w-full max-w-4xl mx-auto">
          <p className="text-[#C5A059] tracking-[0.4em] uppercase text-xs md:text-sm font-light mb-4 animate-fade-in">
            Autoridades GLP
          </p>
          <h1 className="font-serif text-4xl md:text-6xl lg:text-7xl font-normal text-white tracking-tight animate-fade-in [animation-delay:0.3s] drop-shadow-lg mb-6">
            Gran Cuadro
          </h1>
          <p className="text-gray-300 font-light text-base md:text-xl tracking-wide max-w-2xl mx-auto animate-fade-in [animation-delay:0.6s]">
            Dignidades y Oficiales de la Gran Logia del Perú
          </p>
        </div>
      </section>

      {/* Contenido Principal */}
      <section className="relative z-20 max-w-[90rem] mx-auto px-6 lg:px-12 py-16 md:py-24 flex-grow w-full">

        {/* Sección: Gran Maestría (Destacados) */}
        <div className="mb-20">
          <h3 className="font-serif text-3xl text-center text-white mb-12 border-b border-white/10 pb-4 inline-block w-full">Gran Maestría</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            {granMaestria.map((oficial, idx) => (
              <div 
                key={idx} 
                className={`flex flex-col items-center text-center p-8 border ${
                  idx === 0 
                    ? 'bg-gradient-to-b from-[#111111] to-[#0a0a0a] border-[#C5A059]/50 shadow-[0_0_30px_rgba(197,160,89,0.1)] transform md:-translate-y-4' 
                    : 'bg-[#0a0a0a] border-white/5 hover:border-[#C5A059]/30 transition-colors duration-500'
                }`}
              >
                <span className="text-[#C5A059] text-xs tracking-[0.2em] uppercase block mb-6 font-semibold h-10 flex items-center justify-center">
                  {oficial.cargo}
                </span>
                <p className="text-gray-500 text-[11px] tracking-widest uppercase mb-2">{oficial.titulo}</p>
                <h4 className={`font-serif text-white mb-4 leading-tight ${idx === 0 ? 'text-2xl md:text-3xl' : 'text-xl'}`}>
                  {oficial.nombre}
                </h4>
                {oficial.logia && (
                  <span className="inline-block px-3 py-1 border border-white/10 text-gray-400 text-[10px] tracking-widest mt-auto">
                    LOGIA N° {oficial.logia}
                  </span>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Sección: Grandes Oficiales */}
        <div>
          <h3 className="font-serif text-2xl md:text-3xl text-white mb-10 border-b border-white/10 pb-4">Grandes Oficiales</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 md:gap-6">
            {grandesOficiales.map((oficial, idx) => (
              <div 
                key={idx} 
                className="group flex flex-col justify-between bg-[#0a0a0a] border border-white/5 hover:border-[#C5A059]/30 p-6 transition-all duration-300"
              >
                <div>
                  <span className="text-[#C5A059] text-[10px] tracking-[0.2em] uppercase block mb-1 font-semibold group-hover:text-white transition-colors">
                    {oficial.cargo}
                  </span>
                  {oficial.subCargo && (
                    <span className="text-gray-500 text-[9px] tracking-widest uppercase block mb-4">
                      {oficial.subCargo}
                    </span>
                  )}
                  <div className={`flex items-baseline gap-2 ${!oficial.subCargo ? 'mt-3' : 'mt-1'}`}>
                    <span className="text-gray-500 text-[10px] tracking-widest uppercase">{oficial.titulo}</span>
                    <h4 className="font-serif text-lg md:text-xl text-white">{oficial.nombre}</h4>
                  </div>
                </div>
                
                {oficial.logia && (
                  <div className="mt-6 flex justify-end">
                    <span className="text-gray-600 text-[9px] tracking-[0.2em] uppercase font-mono group-hover:text-[#C5A059] transition-colors">
                      N° {oficial.logia}
                    </span>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

      </section>
              
        {/* Lema Oficial */}
        <div className="flex justify-center mb-20">
          <div className="border border-[#C5A059]/30 bg-[#0a0a0a] px-8 py-6 md:px-12 md:py-8 text-center max-w-3xl w-full shadow-2xl relative overflow-hidden">
            <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-10 mix-blend-overlay"></div>
            <h2 className="relative z-10 font-serif text-2xl md:text-4xl text-white font-light italic tracking-wide">
              "Año de la Integridad y la Fraternidad"
            </h2>
          </div>
        </div>
    </div>
  );
};

export default GranCuadro;